import React from "react";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import ConcursosTabla from './ConcursosTabla.jsx';

const ConcursosListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item active">Listado de Concursos</li>
      </ol>
      <h1 className="page-header">Listado de Concursos <small></small></h1>
      <Panel>
        <PanelHeader>Concursos Activos</PanelHeader>
        <PanelBody>
            <ConcursosTabla />
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default ConcursosListar;
